module.exports = __webpack_public_path__ + "img/img-i5gam-tab1.7ed382c4.png";